<template>
    <div id="app" @click="OnAppClick"
         @keydown.esc="OnAppEscape"
         @contextmenu="OnContextMenu">

         
        <component :is="Component"
                   ref="DynamicComponent"
                   :Arguments="DynamicComponentArguments"
                   v-if="Component != null"
                   @hook:mounted="OnDynamicComponentMounted"></component>

        <router-view />

        <t-loading :Visible="IsShowLoading" />
        <t-messagewindow />
        <div style="display:none;">
            <ConfirmDialog />

        </div>

        <PictureMaskWindow />

        <SettingConfirmDialog />





        <!-- Dialogs  -->

        <div style="display:flex;">
            <div v-for="(frame,index) in DialogFrames"
                 @click="OnDialogMaskClick"
                 class="DialogFrame DialogWindow"
                 :class="{'TopMost':index==DialogFrames.length-1}"
                 :style="{'zIndex':100+index*10,'backgroundColor':(index==DialogFrames.length-1)?'rgba(10,10,10,0.6)':'rgba(10,10,10,0.01)','height':DialogHeight+'px'}">

                <div class="ComponentContainer"
                     :style="{'top':frame.DialogTop + 'px' }">
                    <component :is="frame.Component"
                               :Query="frame.Arguments.Query"
                               :Arguments="frame.Arguments"
                               :Mode="frame.Arguments.Mode"
                               :Action="frame.Arguments.Action"
                               :ref="'Dialog_Instance_'+index">
                    </component>
                </div>
            </div>
        </div>


        <!--

    <video autoplay muted loop id="VideoBackground">
        <source :src="$util.PrefixUrl('/static/UploadFile/OfficeBackground.mp4')" type="video/mp4">
        Your browser does not support HTML5 video.
    </video>
        -->


        <div class="ContextMenu Vue" v-show="ContextMenuVisible"
             :style="{left:ContextMenuX + 'PX',top:ContextMenuY + 'px'}">

            <div class="Item"
                 v-for="item in ContextMenuItems"
                 @click="OnConextMenuItemClick(item)"
                 v-html="item.ItemHtml">
            </div>
        </div>

        <div class="ContextMenu Controller" v-show="ContextMenuVisible"
             :style="{left:ControllerContextMenuX + 'PX',top:ControllerContextMenuY + 'px'}">

            <div class="Item"
                 v-for="item in ControllerContextMenuItems"
                 @click="OnConextMenuItemClick(item)"
                 v-html="item.ItemHtml">
            </div>
        </div>
    </div>
</template>

<script>
    import apiService from '@/Common/ApiService';
    import Vue from 'vue';
    import Utility from '@/Common/Utility';
    import PictureMaskWindow from '@/Dialogs/PictureMaskWindow';
    import SettingConfirmDialog from '@/Dialogs/SettingConfirmDialog';
    import ElementDragger from "@/Common/ElementDragger";
    import OpenFileService from "@/Common/OpenFileService";
    import('/static/Css/ListView.css')
    import('/static/Css/DatePicker.css')

    export default {
        name: 'App',

        data: function () {
            return {
                Component: null,

                DynamicComponentRsolveHandler: null,
                DynamicComponentArguments: null,

                ScriptPrefix: "",

                ContextMenuX: 0,
                ContextMenuY: 0,
                ContextMenuItems: [],
                ContextMenuVisible: false,


                ControllerContextMenuX: 0,
                ControllerContextMenuY: 0,
                ControllerContextMenuItems: [],
                ControllerContextMenuVisible: false,

                Hash: Math.round(Math.random() * 10000000),

                SelectorTextList: [],

                browserWidth: 100,

                DialogHeight: 100,

                IsShowLoading: false,

                DialogFrames: [
                ],
            }
        },

        methods: {

            OnDynamicComponentMounted(arg) {

                setTimeout(
                    function () {
                        this.DynamicComponentRsolveHandler(this.$refs.DynamicComponent);
                    }.bind(this)
                    ,
                    400
                );
            },

            LoadComponent(path,args) {
                let resultPromise = new Promise(
                    function (resolve) {
                        this.DynamicComponentArguments = args;
                        this.DynamicComponentRsolveHandler = resolve;
                    }.bind(this)
                );

                let normalizedUrl;
                let url;
                let urlPrefix;
                let postUrl = "";
                let virtualDirectory = "";



                url = path;

                urlPrefix = Utility.GetUrlPrefix();
                normalizedUrl = Utility.NormalizeDialogUrl(url);



                if (url.indexOf("/Dialogs/") > 0) {
                    postUrl = (normalizedUrl + "").replace("/Src" + urlPrefix + "/Dialogs/", "");
                    postUrl = (postUrl + "").replace("@/Dialogs/", "");


                    import("/Src/Dialogs/" + postUrl).then(
                        (module) => {
                            this.Component = module.default;

                            //resolveHandler(this.Component);
                        }
                    ).catch(
                        (ex) => {
                            throw (ex);
                        }
                    );
                }
                else if (url.indexOf("/Controls/") > 0) {
                    postUrl = (normalizedUrl + "").replace("/Src" + urlPrefix + "/Controls/", "");
                    postUrl = (postUrl + "").replace("@/Controls/", "");


                    import("/Src/Controls/" + postUrl).then(
                        (module) => {
                            let frame = {};
                            this.Component = module.default;

                            //resolveHandler(this.Component);
                        }
                    ).catch(
                        (ex) => {
                            throw (ex);
                        }
                    );
                }
                else if (url.indexOf("/Frontend/") > 0) {
                    postUrl = (normalizedUrl + "").replace("/Src" + urlPrefix + "/Frontend/", "");
                    postUrl = (postUrl + "").replace("@/Frontend/", "");


                    import("/Src/Frontend/" + postUrl).then(
                        (module) => {
                            let frame = {};

                            this.Component = module.default;

                            //resolveHandler(this.Component);
                        }
                    ).catch(
                        (ex) => {
                            throw (ex);
                        }
                    );
                }
                else if (url.indexOf("/Payment/") > 0) {
                    postUrl = (normalizedUrl + "").replace("/Src" + urlPrefix + "/Payment/", "");
                    postUrl = (postUrl + "").replace("@/Payment/", "");


                    import("/Src/Payment/" + postUrl).then(
                        function (module) {
                            let frame = {};
                            this.Component = module.default;


                            //resolveHandler(this.Component);
                        }.bind(this)
                    ).catch(
                        (ex) => {
                            throw (ex);
                        }
                    );
                }
                else {
                    postUrl = (normalizedUrl + "").replace("/Src" + urlPrefix + "/Backend/", "");
                    postUrl = (postUrl + "").replace("@/Backend/", "");

                    import("/Src/Backend/" + postUrl).then(
                        (module) => {
                            this.Component = module.default;

                            this.$forceUpdate();

                            // resolveHandler(this.Component);
                        }
                    ).catch(
                        (ex) => {
                            throw (ex);
                        }
                    );
                }


                return resultPromise;
            },


            OnConextMenuItemClick(item) {
                OpenFileService.OpenFileService(item.Path, 1);
            },

            OnContextMenu(e) {
                OpenFileService.OnContextMenu(this, e);
            },




            ChangeStyleSheetRuleBackgroundImage() {
                let sheet, rule;
                let virtualDirectory = "";



                if (typeof (AppSettings) != "undefined" && typeof (AppSettings) == "object") {
                    if (AppSettings.VirtualDirectory != null && AppSettings.VirtualDirectory != "") {
                        virtualDirectory = AppSettings.VirtualDirectory;
                    }
                }

                for (var i = 0; i < document.styleSheets.length; i++) {
                    sheet = document.styleSheets[i];

                    for (var j = 0; j < sheet.cssRules.length; j++) {
                        rule = sheet.cssRules[j];

                        if (rule.selectorText != null) {
                            if (rule.selectorText.indexOf(".Button") >= 0 ||
                                rule.selectorText.indexOf(".DragHandle") >= 0
                            ) {

                                if (rule.style.backgroundImage != null) {
                                    if (rule.style.backgroundImage.indexOf("url(\"/static") == 0) {
                                        if (virtualDirectory != "") {
                                            rule.style.backgroundImage =
                                                rule.style.backgroundImage.replace(
                                                    "url(\"/static",
                                                    "url(\"/" + virtualDirectory + "/static" ,
                                                );
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },

            OnResize(e) {
                alert("resize");
            },

            OnDialogMaskClick(e) {

                if (ElementDragger.LastDropTime != null) {
                    let currDate = new Date();

                    if (currDate - ElementDragger.LastDropTime < 500) {
                        return;
                    }
                }

                if (
                    e.target.classList.contains("ComponentContainer") ||
                    e.target.classList.contains("DialogFrame")
                ) {

                    Utility.CloseDialog();
                }

            },

            OnKeyUp(e) {

                if (e.keyCode == 27) {


                    Utility.CloseDialog();
                }
            },

            OnAppClick(event) {
                let markedElements;
                let i;

                this.ContextMenuVisible = false;

                OpenFileService.Clear();

                this.$bus.$emit("AppClick", event);
            },

            //ClearAllMarkedStyle() {
            //    let markedElements;
            //    let i;

            //    this.ContextMenuVisible = false;

            //    markedElements = document.querySelectorAll(".Marked");

            //    for (i = 0; i < markedElements.length; i++) {
            //        markedElements[i].classList.remove("Marked");
            //    }
            //} ,

            OnAppEscape(event) {
                this.$bus.$emit("AppEscape", event);
            },

            OnResize(event) {
                this.$bus.$emit("AppResize", event);
            },


            OnAppScroll(event) {
                try {
                    this.$bus.$emit("AppScroll", event);
                } catch (ex) {

                }
            },

            OnPictureMaskWindow(pictureItems, picturePath) {

                this.$modal.show("PictureMaskWindow",
                    {
                        PictureItems: pictureItems,
                        StartPicturePath: picturePath
                    }
                );
            },

        },

        components: {
            PictureMaskWindow: PictureMaskWindow,
            SettingConfirmDialog: SettingConfirmDialog
        },

        mounted() {
            let path;


            this.browserWidth = Utility.GetBrowserWidth();

            if (typeof (AppSettings) != "undefined" && typeof (AppSettings) == "object") {
                if (AppSettings.VirtualDirectory != null && AppSettings.VirtualDirectory != "") {

                    setTimeout(
                        this.ChangeStyleSheetRuleBackgroundImage,
                        500
                    );

                    setTimeout(
                        this.ChangeStyleSheetRuleBackgroundImage,
                        1000
                    );

                    setTimeout(
                        this.ChangeStyleSheetRuleBackgroundImage,
                        3000
                    );
                }
            }


            window.addEventListener("resize",
                function () {
                    if (this.browserWidth != Utility.GetBrowserWidth()) {
                        this.OnResize();

                        OpenFileService.Clear();

                        this.browserWidth = Utility.GetBrowserWidth();
                    }
                }.bind(this)
            );

            window.addEventListener("scroll",
                function (e) {
                    this.OnAppScroll(e);
                }.bind(this)
            );


            if ((path = Utility.GetQueryString("Path")) != null) {
                let queryStringList;
                let redirectPath = "";
                let i;


                redirectPath = path;

                queryStringList = Utility.GetQueryStringListBySearchPath(window.location.search.substr(1));

                if (redirectPath.indexOf("?") < 0) {

                    if (queryStringList.some((qi) => qi.Name != 'Path')) {
                        redirectPath += "?";
                    }
                }
                else {
                    redirectPath += "&";
                }


                for (i = 0; i < queryStringList.length; i++) {
                    if (queryStringList[i].Name != "Path") {
                        redirectPath += queryStringList[i].Name + "=" +
                            queryStringList[i].Value + "&";
                    }
                }

                Utility.Goto(redirectPath);

                //Utility.DelayExecute(
                //    () => {
                //        Utility.Confirm(
                //            "Confirm Redirect" ,
                //            `Redirect to '${redirectPath}'  ?`).then(
                //            (result) => {
                //                if (result) {
                //                    Utility.Goto(redirectPath);
                //                }
                //            }
                //        );
                //    },
                //    "D1"
                //);

            }

            window["AppComponent"] = this;

            setTimeout(
                function () {
                    if (window["AppComponentLoad"] != null) {
                        window["AppComponentLoad"](this);
                    }
                }.bind(this),
                200
            );

            setTimeout(
                function () {
                    if (window["AppComponentLoad"] != null) {
                        window["AppComponentLoad"](this);
                    }
                }.bind(this),
                1000
            );

            setTimeout(
                function () {
                    if (window["AppComponentLoad"] != null) {
                        window["AppComponentLoad"](this);
                    }
                }.bind(this),
                4000
            );


        },


        created: async function () {
            let path;


            if (typeof (AppSettings) != "undefined" && typeof (AppSettings) == "object") {
                if (AppSettings.VirtualDirectory != null && AppSettings.VirtualDirectory != "") {
                    this.ScriptPrefix = "/" + AppSettings.VirtualDirectory + "/";
                }
            }

            path = localStorage.getItem("Path");

            window["TopVue"] = this;

            this.$bus.$on("DataLanguageChange",
                (lang) => {
                    //alert(lang);
                    console.log("DataLanguageChange : Language=" + lang)

                    setTimeout(
                        () => {
                            window.location.reload();
                        },
                        100
                    );
                }
            );


            this.$bus.$on('ShowLoading',
                function (event) {
                    this.IsShowLoading = true;
                }.bind(this)
            );

            this.$bus.$on('HideLoading',
                function (event) {
                    this.IsShowLoading = false;
                }.bind(this)
            );

            if (path != null && path != "") {
                localStorage.removeItem("Path");
                if (this.$router.currentRoute.path != path) {
                    this.$router.push(path);
                }
            }


            this.$bus.$on('OpenPictureMaskWindow',
                this.OnPictureMaskWindow.bind(this)
            );

            if (window.location.port == 8080 || window.location.port == 8081) {
                window["BaseUrl"] = Utility.GetBaseUrl();
            }

        }
        ,

        beforeDestroy: function () {
            this.IsShowLoading = false;


            this.$bus.$off('ShowLoading');
            this.$bus.$off('HideLoading');

        }
        ,

        watch: {


            '$route'(to, from) {


                setTimeout(
                    function () {
                        let pageTitleElement;

                        pageTitleElement = document.querySelector(".PageTitle");
                        if (pageTitleElement != null) {
                            //document.title = pageTitleElement.innerText.replace(/^\s+|\s+$/g, '');
                        }

                        if (window["OnBeltsResize"] != null) {
                            window["OnBeltsResize"]();
                        }
                    }
                    ,
                    100
                );


            }
        }
    }
</script>

<style scoped>

    #VideoBackground {
        position: fixed;
        right: 0;
        bottom: 0;
        min-width: 100%;
        min-height: 100%;
        z-index: -1;
        opacity: 0.5;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }
</style>
